import { useFormik } from "formik";
import React, { useCallback, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Api from "../../../core/Api";
import * as Yup from "yup";
import "./cliniclogin.scss";
import { StorageHelpers } from "../../../core/Helpers";
import { useEffect } from "react";

const useLogin = () => {
  const [isPerson, setIsPerson] = useState(true);
  const [showSmsValidationModal, setShowSmsValidationModal] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const refReCaptcha = useRef(null);
  const [branches, setBranches] = useState([]);
  const [branchesLoading, setBranchesLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      firmType: 1,
      idNo: "",
      gsm: "",
      gsmCode: "",
      idBranch: 1,
      SecField1: "",
      SecField2: "",
      turnstileToken: null,
      isRegister: false,
    },
    validationSchema: Yup.object().shape({
      idNo: Yup.string()
        .required("Bu alan boş bırakılamaz.")
        .matches(/^[0-9]+$/, "Geçersiz TC / Vergi numarası girdiniz.")
        .min(10, "TC / Vergi Numarası 10 haneden düşük olamaz.")
        .max(12)
        .nullable(false),
      idBranch: Yup.number().required("Bu alan boş bırakılamaz."),
      gsm: Yup.string().required("Bu alan boş bırakılamaz."),
    }),
    onSubmit: async (val) => {
      setIsLoading(true);
      const isCaptchaVerify = await StorageHelpers.isGoogleRecaptchaVerifyAsync(
        {
          ref: refReCaptcha,
          token: val.turnstileToken,
        }
      );

      if (isCaptchaVerify) {
        const response = await Api.validateAccountAsync(val);
        if (response.data.isSuccess) {
          toast.success("Başarıyla giriş yapıldı.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);

          setShowSmsValidationModal(true);
        } else {
          toast.error("Hatalı giriş yaptınız.", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsLoading(false);
          refReCaptcha.current.reset();
          formik.setFieldValue("turnstileToken", null);
        }
      } else {
        toast.error(
          "Google Recaptcha güvenlik doğrulaması başarısız oldu. Lütfen tekrar deneyiniz..",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        refReCaptcha.current.reset();
        formik.setFieldValue("turnstileToken", null);
        setIsLoading(false);
      }
    },
  });

  const getBranches = async () => {
    setBranchesLoading(true);
    try {
      const response = await Api.getBranchesAsync();
      setBranches(response.data.data);
    } finally {
      setBranchesLoading(false);
    }
  };

  useEffect(() => {
    getBranches();
  }, []);

  const form = {
    legal: {
      onClick: () => {
        setIsPerson(false);
        formik.setFieldValue("firmType", 0);
      },
      className: `${
        isPerson
          ? "bg-[#FFFFFF] text-black opacity-40"
          : " bg-[#4A9DEA] border-[#4A9DEA]"
      }  text-white p-1.5 w-full text-center border text-xl rounded-l-md  cursor-pointer  hover:opacity-80 px-12 duration-300`,
    },
    person: {
      onClick: () => {
        setIsPerson(true);
        formik.setFieldValue("firmType", 1);
      },
      className: `${
        isPerson
          ? " bg-[#4A9DEA] border-[#4A9DEA] "
          : "bg-[#FFFFFF] text-black opacity-40"
      }  text-white w-full text-center text-xl p-1.5 rounded-r-md px-12 border  cursor-pointer  hover:opacity-80 duration-300`,
    },
    idNo: {
      type: "text",
      value: formik.values.idNo,
      onBlur: formik.handleBlur,
      onChange: formik.handleChange,
      placeholder: isPerson ? "TC Kimlik Numarası" : "Vergi Numarası",
      maxLength: "11",
      id: "idNo",
      className: `${
        formik.errors.idNo && formik.touched.idNo && "border-red-600"
      } rounded-md white text-base p-2 pl-4 border-2`,
    },
    gsm: {
      type: "text",
      id: "gsm",
      name: "gsm",
      placeholder: "Telefon Numarası",
      value: formik.values.gsm,
      onBlur: formik.handleBlur,
      mask: "999-999-99-99",
      onChange: formik.handleChange,
      className: `rounded-md white text-base p-2 pl-4  border-2 ${
        formik.touched.gsm && formik.errors.gsm && "border-red-600"
      }`,
    },
    login: {
      disabled: isLoading || formik.values.turnstileToken === null,
      type: "submit",
      className:
        isLoading || formik.values.turnstileToken === null
          ? "bg-gray-600 w-full px-6 text-base py-3 rounded-md text-white hover:bg-gray-700 duration-200"
          : "bg-red-500 w-full px-6 text-base py-3 rounded-md text-white hover:bg-red-600 duration-200",
    },
    gRecaptcha: {
      siteKey: "0x4AAAAAACBTWrwaOHA_UpwR",
      onSuccess: (token) => formik.setFieldValue("turnstileToken", token),
      onError: () => formik.setFieldValue("turnstileToken", ""),
      onExpire: () => formik.setFieldValue("turnstileToken", ""),
      options: {
        theme: "light",
        size: "normal",
      },
      ref: refReCaptcha,
    },
    idBranch: {
      onChange: (e) => formik.setFieldValue("idBranch", e.target.value),
      className: "rounded-md white text-base p-2 pl-4 border-2",
      value: formik.values.idBranch,
    },
  };
  return {
    form,
    formik,
    dispatch,
    navigate,
    setShowSmsValidationModal,
    showSmsValidationModal,
    isPerson,
    isLoading,
    branches,
    branchesLoading,
  };
};

export default useLogin;
